import React from "react";
import IMG from "../../constants/image";
import {clsx} from "clsx";
import ImageBasic from "../Common/Image/ImageBasic";


const Empty = ({imageUrl = IMG.icon.empty, title, description, className, minHeight}) => {
    return (
        <div
            className={clsx("relative rounded-lg mb-5 text-sm bg-white overflow-hidden md:min-h-[400px]")}
            style={{minHeight: minHeight ? `calc(100vh - ${minHeight}px)` : 'calc(100vh - 202px)'}}
        >
            <div
                className="text-center md:py-[100px] absolute text-gray-500 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div>
                    <ImageBasic className={`text-center m-auto p-[15px] ${className}`}
                                src={imageUrl}></ImageBasic>
                    <div className="text-center text-gray-500 ">
                        {title}
                    </div>

                    {description &&
                        <div className="text-center text-gray-500">
                            {description || ''}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Empty;